module.exports = __webpack_public_path__ + "static/Marco-79a873a45706337638d46e1aebbca837.svg";